define('responsive-gameday/views/render/FieldViewRender',['require','exports','module','./ViewRender','Wax/get!view-templates/field/field','Wax/get!view-templates/field/players','Wax/get!view-templates/field/hitchart','Wax/get!view-templates/field/deckHole'],function(require,exports,module){
    var ViewRender = require('./ViewRender'),
        Superclass;

    function FieldViewRender(){
        Superclass.constructor.call(this,
            require('Wax/get!view-templates/field/field'),{
                playersView     : require( 'Wax/get!view-templates/field/players' ),
                hitchartView    : require( 'Wax/get!view-templates/field/hitchart' ),
                deckHoleView    : require( 'Wax/get!view-templates/field/deckHole' )
            }
        );
    }
    ViewRender.spawn(FieldViewRender);

    Superclass=FieldViewRender.superclass;

    return FieldViewRender;
});
